// extracted by mini-css-extract-plugin
export var active = "_gd-7";
export var blink = "_gd-8";
export var dropDownSelector = "_gd-4";
export var dropDownWrapper = "_gd-3";
export var fakeCursor = "_gd-6";
export var fontSizeButton = "_gd-9";
export var formQuillEditor = "_gd-0";
export var pressed = "_gd-a";
export var qlBlank = "_gd-1";
export var textFormattingToolbar = "_gd-2";
export var textToolbarOption = "_gd-5";